import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { WidgetSessionService } from './services/widget-session.service';

/** Captura mid y uuid de la url antes de que el router los descarte */
export function initWidgetSession(sessionSrv: WidgetSessionService) {
  return () => sessionSrv.init();
}

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initWidgetSession,
            deps: [WidgetSessionService],
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
